"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeButtonGroupStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeButtonGroupStyles = function makeButtonGroupStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          '& [class*="MuiButton-root"]': _objectSpread(_objectSpread({
            minWidth: "unset"
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover, &:focus, &:active, &:focus-visible": _objectSpread({
              minWidth: "unset"
            }, tokens.transitions["state-activate"]),
            '& [class*="MuiTypography-root"]': {
              color: "inherit"
            },
            "&:not(:last-of-type) ": {
              borderRadius: "".concat(primitives.spacings["1"], " 0px 0px ").concat(primitives.spacings["1"]),
              "&:hover, &:focus:not(:active), &:focus:focus-visible": {
                borderRight: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-on-background"].rgb),
                borderRadius: "".concat(primitives.spacings["1"], " 1px 1px ").concat(primitives.spacings["1"])
              },
              '&[class*="MuiButton-sizeMedium"]': {
                padding: "3px ".concat(primitives.spacings["2"]),
                "&:hover, &:focus, &:active": {
                  minWidth: "unset"
                },
                '& [class*="MuiButton-startIcon"]': {
                  margin: primitives.spacings["1"],
                  '& [class*="MuiSvgIcon-root"]': {
                    width: primitives.spacings["6"],
                    height: primitives.spacings["6"]
                  }
                },
                '& [class*="MuiTypography-root"]': {
                  margin: "".concat(primitives.spacings["1"], " ").concat(primitives.spacings["3"])
                },
                '& [class*="MuiTypography-root"] ~ [class*="MuiButton-startIcon"]': {
                  marginLeft: primitives.spacings["2"],
                  marginRight: primitives.spacings["1"]
                },
                '& [class*="MuiButton-startIcon"] ~ [class*="MuiTypography-root"]': {
                  marginLeft: primitives.spacings["1"]
                }
              },
              '&[class*="MuiButton-sizeSmall"]': {
                padding: "4.5px ".concat(primitives.spacings["0"]),
                "&:hover, &:focus, &:active": {
                  minWidth: "unset"
                },
                '& [class*="MuiButton-startIcon"]': {
                  marginLeft: primitives.spacings["2"],
                  marginRight: primitives.spacings["1"],
                  '& [class*="MuiSvgIcon-root"]': {
                    width: primitives.spacings["5"],
                    height: primitives.spacings["5"]
                  }
                },
                '& [class*="MuiTypography-root"]': {
                  margin: "".concat(primitives.spacings["0"], " ").concat(primitives.spacings["3"])
                },
                '& [class*="MuiTypography-root"] ~ [class*="MuiButton-startIcon"]': {
                  margin: "".concat(primitives.spacings["0"], " ").concat(primitives.spacings["2"])
                },
                '& [class*="MuiButton-startIcon"] ~ [class*="MuiTypography-root"]': {
                  marginLeft: primitives.spacings["0"],
                  marginRight: primitives.spacings["3"]
                }
              }
            },
            "&:not(:first-of-type) ": {
              borderRadius: "".concat(primitives.spacings["0"], " ").concat(primitives.spacings["1"], " ").concat(primitives.spacings["1"], " ").concat(primitives.spacings["0"]),
              padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
              minWidth: primitives.spacings["8"],
              "&:active": {
                minWidth: "unset"
              },
              "&:hover, &:focus:not(:active), &:focus:focus-visible": {
                borderRadius: "1px ".concat(primitives.spacings["1"], " ").concat(primitives.spacings["1"], " 1px")
              },
              '&[class*="MuiButton-sizeMedium"]': {
                padding: "".concat(primitives.spacings["0"], " ").concat(primitives.spacings["3"]),
                svg: {
                  height: primitives.spacings["6"],
                  width: primitives.spacings["6"]
                }
              },
              '&[class*="MuiButton-sizeSmall"]': {
                padding: "".concat(primitives.spacings["1"], " 10px"),
                minWidth: "unset",
                svg: {
                  height: primitives.spacings["5"],
                  width: primitives.spacings["5"]
                }
              }
            },
            '&[class*="MuiButtonGroup-grouped"]': {
              "&:hover": {
                boxShadow: tokens.effects["halo-hover"].boxShadow
              },
              "&:focus": {
                boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.detail.transparent)
              },
              "&:focus:focus-visible": {
                boxShadow: "0px 0px 0px 1px ".concat(tokens.colors["background"].rgb, ", 0px 0px 0px 3px ").concat(tokens.colors["ink-focus"].rgb)
              },
              "&:active, &:focus:active": {
                boxShadow: tokens.effects["halo-pressed"].boxShadow
              }
            }
          })
        },
        contained: {
          '& [class*="MuiButton-root"]': {
            color: tokens.colors["ink-on-fill-primary"].rgb,
            backgroundColor: tokens.colors["ink-on-background"].rgb,
            "&:hover, &:active, &:focus, &:focus:active": {
              color: tokens.colors["ink-on-fill-primary"].rgb,
              backgroundColor: tokens.colors["ink-on-background"].rgb
            },
            "& svg": {
              color: tokens.colors["ink-on-fill-primary"].rgb
            },
            "&:not(:last-of-type)": {
              marginRight: "1px"
            }
          }
        },
        outlined: {
          '& [class*="MuiButton-root"]': {
            color: tokens.colors["ink-on-background"].rgb,
            backgroundColor: tokens.colors["ink-on-fill-primary"].rgb,
            "&:hover, &:active, &:focus, &:focus:active": {
              color: tokens.colors["ink-on-background"].rgb,
              backgroundColor: tokens.colors["ink-on-fill-primary"].rgb
            },
            "& svg": {
              color: tokens.colors["ink-on-background"].rgb
            },
            "&:not(:last-of-type)": {
              marginRight: "-1px"
            }
          }
        }
      }
    }
  };
};

exports.makeButtonGroupStyles = makeButtonGroupStyles;